import * as React from "react";
import { ScrollArea } from "@edusogno/primitives/scroll-area";
import { cn } from "@edusogno/lib/utils";

const List: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className,
}) => {
  return (
    <ScrollArea
      className={cn(
        "flex h-full max-h-[78cqh] pr-2 overflow-y-auto",
        className,
      )}
    >
      <div className={"flex flex-col gap-4"}>{children}</div>
    </ScrollArea>
  );
};

export default List;
